import { createElement, FC, ReactNode } from 'react';

export type CardTitleProps = {
  children: ReactNode;
  className?: string;
  level?: 2 | 3 | 4;
};

/** A heading at the card-title role, without the caller picking font sizes. */
const CardTitle: FC<CardTitleProps> = ({ children, className, level = 2 }) =>
  createElement('h' + level, { className: ['ui-card-title', className].filter(Boolean).join(' ') }, children);

export default CardTitle;
